import { Logo } from '../components/Logo';
import { navLinks } from '../data/site';
import { cx } from '../lib/cx';
import styles from './Nav.module.css';

export function Nav() {
  return (
    <header className={styles.header}>
      <nav aria-label="Main" className={styles.nav}>
        <a href="#top" aria-label="SeaxDev home" className={styles.home}>
          <Logo size="md" />
        </a>
        <div className={styles.links}>
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} className={styles.link}>
              {link.label}
            </a>
          ))}
          <a href="#contact" className={cx('btn', 'btn--primary', styles.cta)}>
            ./start-project
          </a>
        </div>
      </nav>
    </header>
  );
}
